/**
 * Check if we're on a preview frontend
 */
const isPreviewFrontend = () => {
  const hostname = window.location.hostname;
  return hostname === "preview-fe.dcams.app" ||
    hostname.includes("fe-dcams.pages.dev") ||
    hostname.includes("ngrok") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]" ||
    hostname === "10.0.2.2";
};

/**
 * Get the edge API base URL based on the current hostname.
 * Uses preview.dcams.app for preview-fe.dcams.app and pages.dev deployments.
 * Uses dcams.app for production.
 */
export const getEdgeBaseUrl = () => {
  return isPreviewFrontend() ? "https://preview.dcams.app" : "https://dcams.app";
};

/**
 * Get the edge start_session URL (POST - sends device info, initializes session)
 */
export const getEdgeStartSessionUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/start_session";
  }
  return "https://dcams.app/edge/frontend/api/start_session";
};

/**
 * Get the edge get_session URL (GET - polls for session readiness)
 * Append /{request_id} when calling
 */
export const getEdgeGetSessionUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/get_session";
  }
  return "https://dcams.app/edge/frontend/api/get_session";
};

/**
 * Get the edge queue URL
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeQueueUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/queue/batch";
  }
  return process.env.REACT_APP_EDGE_QUEUE_URL ||
    "https://dcams.app/edge/frontend/api/queue/batch";
};

/**
 * Get the edge status URL
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeStatusUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/status";
  }
  return process.env.REACT_APP_EDGE_STATUS_URL ||
    "https://dcams.app/edge/frontend/api/status";
};

/**
 * Get the edge retrieve URL (for IDMax)
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeRetrieveUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/backend/api/idmax/retrieve";
  }
  return process.env.REACT_APP_EDGE_RETRIEVE_URL ||
    "https://dcams.app/edge/backend/api/idmax/retrieve";
};

/**
 * Get the device signals URL
 * Uses preview.dcams.app for preview/localhost, vx.dcams.app for production
 */
/**
 * Get the capture challenge URL
 * Uses preview.dcams.app for preview/localhost, dcams.app for production
 */
export const getEdgeChallengeUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/capture/challenge";
  }
  return process.env.REACT_APP_EDGE_CHALLENGE_URL ||
    "https://dcams.app/edge/frontend/api/capture/challenge";
};

/**
 * Get the capture envelope signing URL
 * Uses preview.dcams.app for preview/localhost, dcams.app for production
 */
export const getEdgeSignUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/capture/sign";
  }
  return process.env.REACT_APP_EDGE_SIGN_URL ||
    "https://dcams.app/edge/frontend/api/capture/sign";
};

/**
 * Get the device signals URL
 * Uses preview.dcams.app for preview/localhost, vx.dcams.app for production
 */
export const getDeviceSignalsUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/frontend/session/device-signals";
  }
  return "https://vx.dcams.app/frontend/session/device-signals";
};
